import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { startLogout } from "../actions";

class Header extends Component {
  render() {
    return (
      <div>
        <header className="header">
          <div style={{ display: "flex" }}>
            <div style={{ width: "500px", padding: "12px 70px" }}>
              <Link className="header__title" to="/">
                <h1 style={{ fontSize: "2.9em" }}>Tuuli légtechnika</h1>
              </Link>
              <div style={{ color: "white" }}>
                Légtechnikai, szellőzéstechnikai kivitelezés
              </div>
            </div>
            <div className="content-container">
              <div className="header__content">
                <Link className="header__title" to="/ref">
                  <h1>Referencia fotók</h1>
                </Link>
                <Link className="header__title" to="/about">
                  <h1>Rólunk</h1>
                </Link>
                <Link className="header__title" to="/contact">
                  <h1>Elérhetőség</h1>
                </Link>
                {this.props.uid && (
                  <button
                    className="button button--link"
                    onClick={() => this.props.startLogout()}>
                    Logout
                  </button>
                )}
              </div>
            </div>
          </div>
        </header>
        <a
          target="_blank"
          href="https://www.facebook.com/Tuuli-l%C3%A9gtechnikaszell%C5%91z%C3%A9stechnika-743533752656948/"
          className="fa fa-facebook fixedbutton"
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    uid: state.auth.uid,
  };
};

export default connect(
  mapStateToProps,
  {
    startLogout,
  }
)(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js